import { render } from "./Result.vue?vue&type=template&id=5231b288&scoped=true&ts=true"
import script from "./Result.vue?vue&type=script&lang=ts"
export * from "./Result.vue?vue&type=script&lang=ts"

import "./Result.vue?vue&type=style&index=0&id=5231b288&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src536781470/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5231b288"]])

export default __exports__